export default "__VITE_ASSET__BtRGeryK__"